import React from 'react'
import { Box, Typography, LinearProgress, Chip } from '@mui/material'
import HowToVoteIcon from '@mui/icons-material/HowToVote'

function VoteBalanceIndicator({ totalVotes, usedVotes, remainingVotes }) {
  const progress = totalVotes > 0 ? ((totalVotes - remainingVotes) / totalVotes) * 100 : 0

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        p: 2,
        bgcolor: 'background.paper',
        borderRadius: 1,
        border: '1px solid',
        borderColor: 'divider',
      }}
    >
      <HowToVoteIcon color="primary" sx={{ mr: 2 }} />
      <Box flex={1}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
          <Typography variant="body2" color="text.secondary">
            Kuukauden äänet
          </Typography>
          <Chip
            label={`${remainingVotes} / ${totalVotes} jäljellä`}
            size="small"
            color={remainingVotes > 0 ? 'primary' : 'default'}
            variant={remainingVotes > 0 ? 'filled' : 'outlined'}
          />
        </Box>
        <LinearProgress
          variant="determinate"
          value={progress}
          sx={{ height: 8, borderRadius: 4 }}
        />
        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
          {usedVotes > 0
            ? `Olet käyttänyt ${usedVotes} ääntä tässä kuussa`
            : 'Et ole vielä äänestänyt tässä kuussa'}
        </Typography>
      </Box>
    </Box>
  )
}

export default VoteBalanceIndicator
